<script setup lang="js">
import { ref, computed, onMounted } from 'vue'
import { supabase } from '@/supabase'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Button from 'primevue/button';
import ProgressBar from 'primevue/progressbar';
import { useRouter } from 'vue-router';
import Toast from 'primevue/toast';

const router = useRouter();
const store = useStore();
const route = useRoute();
const loadingHeader = computed(() => store.state.loading);

const idGrupo = ref(0);
onMounted(() => {
    if (route.query.id != undefined) {
        idGrupo.value = route.query.id;
        carregarGrupos();
    } else {
        router.go(-1);
    }
})

function goBack() {
    router.go(-1);
}

const grupos = ref([]);


async function carregarGrupos() {
    let { data, error } = await supabase
        .from('grupos')
        .select('id, nome, grupos_planos(plano), grupos_estudantes(numero_grupo, estudante, users(id, nome, img))')
        .eq('id', idGrupo.value)

    if(error){
        console.log(error);
        return;
    }
    
    grupos.value = formatarGrupos(data[0].grupos_estudantes);
}

function formatarGrupos(dadosOriginais) {
    const dadosAgrupados = dadosOriginais.reduce((grupos, item) => {
        if (!grupos[item.numero_grupo]) {
            grupos[item.numero_grupo] = {
                numero_grupo: item.numero_grupo,
                nome: 'Grupo ' + item.numero_grupo,
                estudantes: []
            };
        }
        grupos[item.numero_grupo].estudantes.push({
            id: item.users.id,
            nome: item.users.nome,
            img: item.users.img
        });

        return grupos;
    }, {});


    return Object.values(dadosAgrupados);

}



</script>
<template>
    <ProgressBar v-if="loadingHeader" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
    <Toast />
    <div class="header border-bottom-1 border-200 z-3">
        <div class="flex justify-content-between align-items-center w-full">
            <div class="text-color-secondary text-xl flex align-items-center">
                <Button @click="goBack" icon="pi pi-arrow-left" text rounded aria-label="Filter" severity="secondary" />
                <span class="ml-2">Voltar</span>

            </div>

        </div>
    </div>
    <div class="surface-50 pt-8 pb-8">


        <div class="container-fluid" style="max-width: 1900px">
            <div class="grid">
                <div class="col" v-for="(grupo, index) in grupos" :key="index">
                    <div class="bg-white border-1 border-round border-200 p-3">
                        <div class="flex justify-content-between">
                            <div class="font-medium">
                                {{ grupo.nome }}
                            </div>
                            <div class="font-medium">{{ grupo.estudantes.length }}</div>
                        </div>
                        <div class="flex flex-column gap-5 mt-3">
                            <div v-for="estudante in grupo.estudantes" :key="estudante.id"
                                class="flex align-items-center column-gap-2">
                                <span>
                                    <div class="text-sm font-medium text-color mb-1">{{ estudante.nome }} </div>
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>



    </div>
</template>